// extracted by mini-css-extract-plugin
export default {"preview":"TemplatePreview_preview__J0c3z"};